import { render } from "./AdminHeroSlides.vue?vue&type=template&id=f63385d0&scoped=true"
import script from "./AdminHeroSlides.vue?vue&type=script&lang=js"
export * from "./AdminHeroSlides.vue?vue&type=script&lang=js"

import "./AdminHeroSlides.vue?vue&type=style&index=0&id=f63385d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f63385d0"]])

export default __exports__